// src/colors.ts

export interface ColorOption {
  name: string;
  hex: string;
}

export const COLORS: ColorOption[] = [
  { name: "Dark Orange", hex: "#FF8C00" },
  { name: "Gold", hex: "#FFD700" },
  { name: "Green", hex: "#2CA02C" },
  { name: "Light Green", hex: "#98DF8A" },
  { name: "Olive", hex: "#808000" },
  { name: "Saddle Brown", hex: "#8B4513" },
  { name: "Tan", hex: "#D2B48C" },
  { name: "Khaki", hex: "#F0E68C" },
  { name: "Teal", hex: "#008080" },
  { name: "Turquoise", hex: "#40E0D0" },
  { name: "Hot Pink", hex: "#FF69B4" },
  { name: "Light Pink", hex: "#FFB6C1" },
  { name: "Slate Gray", hex: "#708090" },
  { name: "Dim Gray", hex: "#696969" },
  { name: "Mustard", hex: "#FFDB58" },
  { name: "Medium Aquamarine", hex: "#66CDAA" },
];
